import { z } from "zod";

export const submitOrderSchema = z.object({
  hasAgreedToTerms: z.literal<boolean>(true, {
    errorMap: () => ({
      message: "Please read and accept our terms and conditions",
    }),
  }),
});
